import {
  GenerateGameWordCode,
  GenerateRandomGameWordCode,
  GetGameWordCodeValidationRule,
  GetGameWordValidationRule,
} from '../domain/game-word-service';

export const useInitGameState = {
  GetGameWordCodeValidationRule,
  GetGameWordValidationRule,
  GenerateGameWordCode,
  GenerateRandomGameWordCode,
};
